<template>
  <Layout>
    <h2 class="page-title">{{$t('pages_title')}}</h2>
    <div class="filter-wrapper">
      <PageFilters />

      <div class="justify-end-div">
        <ExpandableSearch />
        <div class="log-icon-wrapper">
          <img src="@/assets/images/logIconNew.svg" @click="showLogModal" class="log-icon" />
          <span class="tooltip">{{ $t('log_records') }}</span>
        </div>
        <LogModal
            :visible="isLogModalVisible"
            :on-hide="hideLogModal"
            :data="logData"
            :total-items="logMeta.total"
            :current-page="logMeta.currentPage"
            :per-page="logMeta.perPage"
            :on-page-change="handleLogPageChange"
        />
        <router-link to="/page/new">
          <div class="justify-end-add-btn no-text-select">
            <img src="../assets/images/plus.svg" />
            <span>{{$t('add_new')}}</span>
          </div>
        </router-link>
      </div>
    </div>

    <div v-if="!isLoading && pageData.data && pageData.data.length === 0" class="no-results">
      <p>{{ $t('no_pages_found') }}</p>
    </div>

    <div class="page-list-grid" v-else>
      <PageCard
          v-for="item in pageData.data"
          :is-loading="isLoading"
          :title="item.name"
          :is-publish="item.status"
          :description="stripHtmlTags(truncate(item.description, 100))"
          :to="`/page/${item.pageId}`"
      />

      <PageCard v-if="isLoading" />
      <PageCard v-if="isLoading" />
      <PageCard v-if="isLoading" />
    </div>


    <div class="pagination-align-center">
      <Pagination :current-page="currentPage" :total-items="pageData.total" :per-page="20" :on-page-change="handlePage"/>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";
import Pagination from "@/components/Pagination.vue";
import ExpandableSearch from "@/components/ExpandableSearch.vue";
import {handleErrorResponse, stripHtmlTags, truncate} from "@/utils/utils";
import pageService from "@/service/pageService";
import PageCard from "@/components/PageCard.vue";
import PageFilters from "@/components/tables/Page/PageFilters.vue";
import LogModal from "@/components/modals/LogModal.vue";

export default {
  name: 'Pages',
  components: {
    LogModal,
    PageFilters,
    PageCard,
    ExpandableSearch,
    Pagination,
    Layout
  },
  data() {
    return {
      logData: [],
      logMeta: {
        total: 0,
        currentPage: 1,
        perPage: 20
      },
      isLogModalVisible: false,
      isLoading: true,
      pageData: {
        data: [],
        total: 0
      },
      currentPage: 1,
    }
  },
  watch: {
    $route() {
      this.handlePage(1);
    }
  },
  mounted() {
    // getLogs kaldırıldı - modal açılınca çağrılacak
    this.handlePage(1);
  },
  methods: {
    getLogs(page = 1) {
      pageService.getLogs(this.$i18n.locale, page, 20).then((res) => {
        const response = res.data.data;
        this.logData = response.data;
        this.logMeta = {
          total: response.total,
          currentPage: response.current_page,
          perPage: response.per_page
        };
      }).catch((err) => {
        handleErrorResponse(err, this.$snackbar);
      });
    },

    handleLogPageChange(page) {
      if (this.logMeta.currentPage === page) return;
      this.logMeta.currentPage = page;
      this.getLogs(page);
    },

    showLogModal() {
      this.isLogModalVisible = true;
      this.logMeta.currentPage = 1;
      this.getLogs(1);
    },

    hideLogModal() {
      this.isLogModalVisible = false;
    },

    truncate,
    stripHtmlTags,

    handlePage(page) {
      if (this.isLoading && this.currentPage !== 1) return;

      this.isLoading = true;
      this.currentPage = page;

      const routeQuery = this.$route.query;
      const tempFilters = [];

      if (routeQuery.searchText) {
        tempFilters.push({
          key: 'searchText',
          value: routeQuery.searchText
        });
      }

      if (routeQuery.addedDate) {
        tempFilters.push({
          key: 'createdAt',
          value: routeQuery.addedDate
        });
      }

      if (routeQuery.addedDateEnd) {
        tempFilters.push({
          key: 'createdAtEnd',
          value: routeQuery.addedDateEnd
        });
      }

      pageService.getPages(page, tempFilters).then((res) => {
        this.pageData = res.data.data;
      }).catch((err) => {
        handleErrorResponse(err, this.$snackbar);
      }).finally(() => {
        this.isLoading = false;
      });
    },
  }
}
</script>

<style scoped>
.page-title {
  font-family: euclid_medium, sans-serif;
  font-size: 20px;
  color: #040C2D;
  margin-bottom: 20px;
}
.filter-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.filter-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}
.filter-dropdown {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
  border-radius: 8px;
  padding: 8px;
  background-color: #f2f2f2;
  position: relative;
  cursor: pointer;
}
.dropdown-text {
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
  font-weight: 500;
  font-style: normal;
  white-space: nowrap;
}

.no-results {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  width: 100%;
}

.no-results p {
  font-family: euclid_medium, sans-serif;
  font-size: 16px;
  color: #6B7280;
  text-align: center;
}

.page-list-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

@media (max-width: 1024px) {
  .page-list-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .page-list-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
